import { render, staticRenderFns } from "./SharedLinkContent.vue?vue&type=template&id=2af610cc&scoped=true"
import script from "./SharedLinkContent.vue?vue&type=script&lang=ts"
export * from "./SharedLinkContent.vue?vue&type=script&lang=ts"
import style0 from "./SharedLinkContent.vue?vue&type=style&index=0&id=2af610cc&lang=scss&scoped=true"
import style1 from "./SharedLinkContent.vue?vue&type=style&index=1&id=2af610cc&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af610cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2af610cc')) {
      api.createRecord('2af610cc', component.options)
    } else {
      api.reload('2af610cc', component.options)
    }
    module.hot.accept("./SharedLinkContent.vue?vue&type=template&id=2af610cc&scoped=true", function () {
      api.rerender('2af610cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/SharedLinkContent.vue"
export default component.exports